module.exports = __webpack_public_path__ + "static/media/CS.520b503f.png";